// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__N8Op9","title":"header_title__iP6xt","close":"header_close__3QD_0"};